angular.module('bmsApp.sm.job')
	.controller('SMCopyJobModalCtrl',
		function ($state,
				  $modalInstance,
				  $scope,
				  SMJobSvc,
				  job) {


			function init() {
				self.job = job;
				self.copyMethod = "1"; // copy and reset
			}


			function cancel() {
				$modalInstance.dismiss('cancel');
			}

			function submit() {
				var copyMethod = (self.copyMethod == "1") ? 'copy_rrp' : 'copy_exact';
				var params = {
					jobId: self.job.id,
					method: copyMethod
				};
				SMJobSvc.copy(params).then(function(response) {
					$modalInstance.close(response.data.job);
				});
			}

			var self = $scope.SMCopyJobCtrl = {
				loading: true,
				job: {},
				methods: {
					init: init,
					cancel: cancel,
					submit: submit
				}
			}

		});
